var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoDefaultItem(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    transform: "scale(-1,1)",
    width: "208px",
    height: "104px",
    viewBox: "0 0 208 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "image copy 17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 208,
    height: 104
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tests",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-3",
    transform: "translate(-1657.000000, -643.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cards/generic/default",
    transform: "translate(1641.000000, 571.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image-copy-17",
    transform: "translate(16.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "car",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.500000, 52.500000) scale(-1, 1) translate(-104.500000, -52.500000) translate(8.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2896324,58.375 C16.6879131,58.375 11.2853342,58.375 4.08189566,58.375 C-1.04219979,54.8504635 0.0247341454,40.7419725 1.4260976,36.5584862 C2.82746106,32.375 12.2360986,25.7260966 34.3708625,21.9254587 C56.5056265,18.1248208 53.080799,18.5457282 62.5343607,13.9438073 C71.9879224,9.34188647 82.991997,0.375 106.106469,0.375 C129.220941,0.375 139.041894,0.518420298 151.271641,5.69610092 C163.501389,10.8737815 178.665072,17.934633 187.404609,17.934633 C187.383853,17.934633 187.383853,17.934633 187.404609,34.4300459 L191.390901,36.5584862 C193.616693,45.7817278 192.287929,51.7236239 187.404609,54.3841743 C184.71536,55.8493425 177.625262,56.9110758 166.134316,57.5693742",
    id: "Path",
    stroke: "#A5ADBD",
    strokeWidth: 1,
    fillOpacity: 0.2,
    fill: "#D8D8D8",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    strokeOpacity: 0.6,
    stroke: "#F93232",
    strokeWidth: 1,
    fillOpacity: 0.4,
    fill: "#F93232",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(183.436211, 26.375000) scale(-1, 1) translate(-183.436211, -26.375000) ",
    points: "179.436211 29.375 187.436211 29.375 187.436211 23.375 179.436211 23.375"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "------------",
    stroke: "#F9D66A",
    strokeWidth: 1,
    fillOpacity: 0.3,
    fill: "#F9CF6A",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "0.436210815 42.375 9.34174124 42.375 13.4362108 36.375 1.4149307 36.375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.436211,22.375 L60.4362108,22.375 C72.8361945,11.7083333 90.3674445,6.375 113.029961,6.375 C135.692477,6.375 152.161227,11.7083333 162.436211,22.375 Z",
    id: "Path-6",
    stroke: "#A5ADBD",
    strokeWidth: 1,
    fillOpacity: 0.3,
    fill: "#D8FFFA",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2896324,58.375 C16.6879131,58.375 11.2853342,58.375 4.08189566,58.375 C-1.04219979,54.8504635 0.0247341454,40.7419725 1.4260976,36.5584862 C2.82746106,32.375 12.2360986,25.7260966 34.3708625,21.9254587 C56.5056265,18.1248208 53.080799,18.5457282 62.5343607,13.9438073 C71.9879224,9.34188647 82.991997,0.375 106.106469,0.375 C129.220941,0.375 139.041894,0.518420298 151.271641,5.69610092 C163.501389,10.8737815 178.665072,17.934633 187.404609,17.934633 C187.383853,17.934633 187.383853,17.934633 187.404609,34.4300459 L191.390901,36.5584862 C193.616693,45.7817278 192.287929,51.7236239 187.404609,54.3841743 C184.71536,55.8493425 177.625262,56.9110758 166.134316,57.5693742",
    id: "Path",
    stroke: "#A5ADBD",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.404476,7 C127.873125,7 115.208187,15.6503906 112.647949,22.4967764 C112.647949,22.4967764 122.684142,22.4561843 142.756527,22.375 L140.404476,7 Z",
    id: "Path",
    stroke: "none",
    fill: "#6BC4D8",
    fillRule: "evenodd",
    opacity: 0.161202567,
    transform: "translate(127.702238, 14.748388) scale(-1, 1) translate(-127.702238, -14.748388) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6490216,11.1381182 C64.8279134,14.0080142 61.0809925,18.6646453 59.6479492,22.4967764 C59.6479492,22.4967764 70.3508084,22.4561843 91.7565269,22.375 C80.387001,14.0273438 73.6844992,10.2817165 71.6490216,11.1381182 Z",
    id: "Path",
    stroke: "none",
    fill: "#6BC4D8",
    fillRule: "evenodd",
    opacity: 0.161202567,
    transform: "translate(75.702238, 16.757684) scale(-1, 1) translate(-75.702238, -16.757684) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.436211,22.375 L60.4362108,22.375 C72.8361945,11.7083333 90.3674445,6.375 113.029961,6.375 C135.692477,6.375 152.161227,11.7083333 162.436211,22.375 Z",
    id: "Path-6",
    stroke: "#A5ADBD",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#A5ADBD",
    strokeWidth: 1,
    fill: "#EDE9E9",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 34.4362108,
    cy: 53.375,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#A5ADBD",
    strokeWidth: 1,
    fill: "#EDE9E9",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 151.436211,
    cy: 53.375,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.220941,58.375 C89.8762382,58.375 63.0418489,58.375 48.7177735,58.375",
    id: "Path",
    stroke: "#A5ADBD",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136.436211,
    y1: 50.375,
    x2: 49.57748,
    y2: 50.375,
    id: "Path",
    stroke: "#A5ADBD",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#A5ADBD",
    strokeWidth: 1,
    fill: "#F7F7F7",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 151.436211,
    cy: 53.375,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#A5ADBD",
    strokeWidth: 1,
    fill: "#F7F7F7",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 34.4362108,
    cy: 53.375,
    r: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112.647949,
    y1: 22.375,
    x2: 115.063789,
    y2: 6.875,
    id: "Path",
    stroke: "#A5ADBD",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoDefaultItem);
export default __webpack_public_path__ + "static/media/PictoDefaultItem.a85267c9919f614f14efa1a643dae3db.svg";
export { ForwardRef as ReactComponent };